<template>
	<svg
		width="19px"
		height="19px"
		viewBox="0 0 19 19"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		:style="color && { '--color': color }"
	>
		<g stroke="none" fill="none" stroke-width="1" fill-rule="evenodd">
			<g transform="translate(-480.000000, -365.000000)">
				<g transform="translate(421.000000, 113.000000)">
					<g transform="translate(59.000000, 249.000000)">
						<g transform="translate(0.000000, 3.000000)">
							<circle
								class="visible"
								stroke-width="2"
								cx="9.5"
								cy="9.5"
								r="8.5"
							></circle>
							<g
								transform="translate(9.506583, 9.612976) scale(-1, 1) translate(-9.506583, -9.612976) translate(8.264765, 4.354167)"
								fill-rule="nonzero"
								class="visible"
							>
								<path
									d="M2.48363636,9.26210335 C2.48363636,9.95439416 1.92655673,10.5176181 1.24181818,10.5176181 C0.557079636,10.5176181 3.06954462e-12,9.95439416 3.06954462e-12,9.26210335 C3.06954462e-12,8.56981254 0.557079636,8.00658864 1.24181818,8.00658864 C1.92655673,8.00658864 2.48363636,8.56981254 2.48363636,9.26210335 Z M0.242249594,0.535745341 L0.434419976,6.31862295 C0.443449157,6.59018433 0.592409464,6.80338542 0.773120273,6.80338542 L1.71051609,6.80338542 C1.8912269,6.80338542 2.04018721,6.59018433 2.04921639,6.31862295 L2.24138677,0.535745341 C2.25106594,0.244284058 2.09663726,0 1.90268647,0 L0.580949892,0 C0.386999108,0 0.232570424,0.244284058 0.242249594,0.535745341 Z"
								></path>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'ExclamationIcon',
	props: {
		color: String,
	},
}
</script>
<style>
circle.visible {
	stroke: var(--color, #f9bb22);
}
g.visible {
	fill: var(--color, #f9bb22);
}
</style>
